import { ModelCommon, UserAttributeDef, UserAttributeDefs, toDatePickerFormat, ValidModelType } from '@iotv/datamodel-core';
import { isValidBusinessObject, MapLike, PathDirection, Position } from '@iotv/iotv-v3-types';

const typeName = 'Pond';

export type PondProps = {
  purpose?: string;
  capacity?: number;
  diameter?: number;
  depth?: number;
  floorSize?: number;
  topArea?: number;
  constructionMaterial?: string;
  location?: Position;
  image?: string;
  
};

export class Pond extends ModelCommon {
  constructor(ob: any) {
    super(ob.type || typeName, ob);
  }

  purpose?: string;
  capacity?: number;
  diameter?: number;
  depth?: number;
  floorSize?: number;
  topArea?: number;
  constructionMaterial?: string;
  location?: Position;
  image?: string;
  

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      name: { type: 'String', editable: true, label: 'Name', name: 'name', description: 'Name of pond' },
      purpose: { type: 'String', editable: true, label: 'Purpose', name: 'purpose', description: 'Used for' },
      capacity: { type: 'Number', editable: true, label: 'Capacity', name: 'capacity', description: 'Total capacity of pond in m3 and litres' },
      diameter: { type: 'Number', editable: true, label: 'Diameter', name: 'diameter', description: 'Diameter of pond - metre.cm' },
      depth: { type: 'Number', editable: true, label: 'Depth', name: 'depth', description: 'Depth of pond in m.cm' },
      floorSize: { type: 'Number', editable: true, label: 'Floor Size', name: 'floorSize', description: 'Area of the floor of the pond in m2' },
      topArea: { type: 'Number', editable: true, label: 'Top Area', name: 'topArea', description: 'Area of the top of the pond in m2' },
      constructionMaterial: {
        type: 'String',
        editable: true,
        label: 'Construction material',
        name: 'constructionMaterial',
        description: 'Material dam is contructed from if artifical',
      },
      location: { type: 'object', editable: true, label: 'Location', name: 'location', description: 'Boundary points of pond'},
      image: { type: 'String', editable: true, label: 'Image', name: 'image', description: 'Photograph of dam' },
      comments: { type: 'String', editable: true, label: 'Comments', name: 'comments', description: 'Free text for info ' },
    };
  };
}
